import Transform from './Base';

export default class FilesTransform extends Transform {
  /**
   * Method used to transform fetched files.
   *
   * @param file The fetched file.
   *
   * @returns {Object} The transformed file.
   */
  static fetch(file) {
    const { metadata = {} } = file;
    const {
      existing_frames: existing = 0,
      fps = 0,
      frame_height: height = 0,
      frame_width: width = 0,
      total_frames: total = 0,
    } = metadata;
    return {
      comments: file.comments ?? '',
      frames: {
        existing,
        total,
      },
      id: file._id,
      game_date: file.game_date,
      name: file.video_name,
      size: file.video_size,
      hash: file.video_hash,
      url: file.video_url,
      created_at: file.created_at,
      updated_at: file.updated_at,
      fps,
      height,
      width,
      total_frames: total,
      uploaded: file.created_at !== undefined && file.created_at !== "",
      modified: file.updated_at !== undefined && file.updated_at !== "",
      preview_url: file.thumbnail,
      aspect_ratio: height !== 0 ? width / height : 0,
      duration_sec: fps !== 0 ? total / fps : 0,
      referee_outfit_id: file.referee_outfit_id,
      team_a: file.team_a,
      team_a_id: file.team_a_id,
      team_a_gk_outfit_id: file.team_a_gk_outfit_id,
      team_a_outfit_id: file.team_a_outfit_id,
      team_b: file.team_b,
      team_b_id: file.team_b_id,
      team_b_gk_outfit_id: file.team_b_gk_outfit_id,
      team_b_outfit_id: file.team_b_outfit_id,
      venue: file.venue,
      venue_id: file?.venue?._id,
      status: file.status,
    };
  }
}
